import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  Modal,
  ModalCancelButton,
  ModalSaveButton,
  ModalButtonGroup,
} from "../../components";
import * as select from "../../reducers";
import * as actions from "../../actions/modals";

class ConfirmModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string,
    description: PropTypes.string,
    buttonText: PropTypes.string,
    buttonType: PropTypes.oneOf(["", "saving", "success", "error"]),
    onClick: PropTypes.func,
  };
  render() {
    const {
      isOpen,
      setModalConfirmClosed,
      title,
      description,
      buttonText,
      buttonType,
      onClick,
    } = this.props;

    // If there is a selected program, return the modal allowing the user to edit the donation
    return (
      <Modal
        isOpen={isOpen}
        modalName="edit-program"
        onClose={setModalConfirmClosed}
      >
        <div className="remodal remodal--help" data-remodal-id="help-modal">
          <div className="help_content help_content--top form">
            <div dangerouslySetInnerHTML={{ __html: title }} />
            <div
              className="flex-row form__row"
              dangerouslySetInnerHTML={{ __html: description }}
            />
            <div className="flex-row form__finalise-changes">
              <ModalButtonGroup>
                <ModalCancelButton
                  action="close"
                  onClick={setModalConfirmClosed}
                >
                  Cancel
                </ModalCancelButton>
                <ModalSaveButton variant={buttonType} onClick={onClick}>
                  {buttonText}
                </ModalSaveButton>
              </ModalButtonGroup>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isOpen: select.getConfirmModalOpen(state),
  };
};

export default connect(mapStateToProps, actions)(ConfirmModal);
